export default function datepickerDefaultDayHighlight() {
  'ngInject';

  return {
    restrict: 'AE',
    bindToController: {
      defaultDate: '=datepickerDefaultDayHighlight',
    },
    controller() {},
  };
}
